import { useAppSelector } from '@/globalStore/hooks.ts'
import { Permission } from '@/core/types/permissions/Permission.ts'
import { useCallback } from 'react'

const useHasPermissions = () => {
  const { loggedUser } = useAppSelector((state) => state.global)

  const hasPermissions = useCallback(
    (requiredPermissions: Permission[]) => {
      if (loggedUser && requiredPermissions) {
        return requiredPermissions.some((permission) => {
          return loggedUser.permissions[permission]
        })
      }
      return false
    },
    [loggedUser]
  )

  /**
   * if user have at least one of the blocking permissions always returns false
   * else returns the result of hasPermissions
   */
  const hasPermissionsWithBlockingPermissions = useCallback(
    (requiredPermissions: Permission[], blockingPermissions: Permission[]) => {
      if (loggedUser && requiredPermissions && blockingPermissions) {
        const userHasBlockingPermission = hasPermissions(blockingPermissions)
        if (userHasBlockingPermission) return false
        else return hasPermissions(requiredPermissions)
      }
    },
    [loggedUser]
  )

  return { hasPermissions, hasPermissionsWithBlockingPermissions }
}

export default useHasPermissions
